/* Buy Again on order lines (Owen 2026-10-21). Markup: snippets/order-line-items.liquid (.nt-bia).
   Rest:  "6 at $5.20 ea" · line total · [Buy Again]
   Open:  [qty ▲▼] · price each (with the quantity break) · new total · [Add to Cart] [X]
   The add itself is NOT here: Add to Cart is the line's existing .ao-li-reorder-btn, whose handlers
   (sections/my-orders-content.liquid, sections/members-portal-layout.liquid, sections/all-orders.liquid)
   read data-quantity at click time. This file only keeps data-quantity in step with the box.
   Order Details (renderOdLineItem in members-portal-layout) shows copies of the same list lines, matched
   by line item id, so its Add to Cart runs the same handler. Breaks: assets/nt-qty-tiers.js.
   Several lines open (Owen 2026-10-21; across orders since 10-22): they count toward each other's break
   (the cart will count them together), and one bar under the line being edited adds them all in ONE /cart/add.js call; if
   Shopify refuses the batch, lines go one at a time and any that fail stay open with an error.

   Ninja Patches port (2026-10-23): a custom-patch line can't go under its minimum (data-min: custom.min_quantity, else
   25 tackle twill / 10 patches — snippets/order-line-items.liquid); its price each comes from the product's own volume
   tiers (assets/nt-qty-tiers.js reads its product page), only once the line is visible, so My Orders loads no product
   pages up front; the batch add builds each line's properties exactly as NP's own line Reorder does. */
(function () {
  'use strict';
  if (window.__ntBuyAgain) return;
  window.__ntBuyAgain = true;

  var HOST = '[data-nt-bia]';
  function money(c) {
    return '$' + (Math.round(c) / 100).toFixed(2).replace(/\B(?=(\d{3})+(?!\d))/g, ',');
  }
  function num(v) { return parseInt(String(v || '').replace(/\D/g, ''), 10) || 0; }
  function maxOf(h) { return num(h.getAttribute('data-max')); }
  function minOf(h) { return Math.max(1, num(h.getAttribute('data-min'))); }
  function clamp(h, n) {
    var m = maxOf(h), lo = minOf(h);
    n = Math.max(lo, Math.min(9999, n || lo));
    return m ? Math.min(n, m) : n;
  }
  function q(h, sel) { return h.querySelector(sel); }
  function realBtn(h) { return q(h, '.ao-li-reorder-btn'); }
  function ordered(h) { return clamp(h, num(h.getAttribute('data-ordered'))); }
  /* the order a line belongs to: its line list, or the Order Details panel */
  /* every open line on the page counts together and shares one bar, across orders (Owen 2026-10-22: the cart
     counts them together, so the discount and the bar carry between cards); Order Details keeps its own */
  function scopeOf(h) { return h.closest('[data-panel="order-detail"]') || document.body; }
  function openIn(scope) { return [].slice.call(scope.querySelectorAll(HOST + '.is-open')); }
  function qtyOf(h) { var i = q(h, '.nt-bia-qn'); return i ? clamp(h, num(i.value)) : ordered(h); }
  function group(h) { return window.NTQtyTiers ? window.NTQtyTiers.groupKey(h.getAttribute('data-type')) : ''; }
  /* other OPEN lines of this order: the cart will count them with this one (same break group for
     quantity breaks; every line's dollars for the blanks cart-total ladder) */
  function also(h) {
    var g = group(h), qty = 0, total = 0;
    openIn(scopeOf(h)).forEach(function (o) {
      if (o === h) return;
      var n = qtyOf(o);
      total += num(o.getAttribute('data-unit')) * n;
      if (g && group(o) === g) qty += n;
    });
    return { qty: qty, total: total };
  }
  /* today's price each for h at n pieces, with today's discounts (assets/nt-qty-tiers.js) */
  function livePrice(h, n, withOpen) {
    var unit = num(h.getAttribute('data-unit')), x = withOpen ? also(h) : { qty: 0, total: 0 };
    if (!window.NTQtyTiers) return Promise.resolve({ each: unit, off: 0, unit: unit, x: x });
    return window.NTQtyTiers.price({ unit: unit, qty: n, type: h.getAttribute('data-type'), tiers: h.getAttribute('data-tiers'), handle: h.getAttribute('data-handle'), min: minOf(h), alsoQty: x.qty, alsoTotal: x.total })
      .then(function (r) { r.unit = unit; r.x = x; return r; });
  }
  /* the line's Pre-cut sub-line follows its quantity */
  function paintPc(h, n) {
    var row = h.closest('.ao-line-item'), id = row && row.getAttribute('data-nt-line');
    var list = row && row.parentNode, pc = id && list ? list.querySelector('.ao-li-pc-sub[data-nt-pc-of="' + id + '"]') : null;
    if (!pc) return;
    var p = pc.querySelector('.ao-li-price'), s = pc.querySelector('.ao-li-sub');
    if (p) p.textContent = money(num(pc.getAttribute('data-pc-unit')) * n);
    if (s) s.textContent = n + (n === 1 ? ' piece' : ' pieces');
  }
  /* at rest: "N at $X ea" + total = buying the ordered quantity again today */
  function paintRest(h) {
    if (h.classList.contains('is-open')) return;
    /* NP: a custom-patch line's price needs its product's tier table (a product page read) — only once the line shows
       (See all / +N more, Order Details, a single-item card's own line); the Liquid price stays until then */
    var vis = h.closest('.ao-line-item, .od-line-item') || h;   /* the ROW: an open line elsewhere hides this one's price cells, not the row */
    if (minOf(h) > 1 && !vis.offsetParent) { h.__restWait = true; return; }
    h.__restWait = false;
    var n = num(h.getAttribute('data-ordered')) || 1, token = (h.__rest = (h.__rest || 0) + 1);
    paintPc(h, n);
    livePrice(h, n, false).then(function (r) {
      if (token !== h.__rest || h.classList.contains('is-open')) return;
      var ea = q(h, '.nt-bia-sum-ea'), tot = q(h, '.ao-li-price');
      if (ea) ea.textContent = money(r.each);
      if (tot) tot.textContent = money(r.each * n);
    }, function () {});
  }
  function paintAllRest(root) {
    (root || document).querySelectorAll('[data-nt-price]').forEach(paintRest);
  }
  function paintAll(h) {
    openIn(scopeOf(h)).forEach(function (o) { if (o !== h) paint(o, true); });
    syncBar(scopeOf(h));
  }

  function paint(h, quiet) {
    var inp = q(h, '.nt-bia-qn'), n = clamp(h, num(inp.value));
    var btn = realBtn(h);
    if (btn) btn.setAttribute('data-quantity', String(n));
    var up = q(h, '[data-nt-step="1"]'), dn = q(h, '[data-nt-step="-1"]'), m = maxOf(h);
    if (dn) dn.disabled = n <= minOf(h);
    if (up) up.disabled = !!(m && n >= m);
    var cap = q(h, '.nt-bia-cap');
    if (cap) { cap.hidden = !(m && n >= m); cap.textContent = m ? 'Only ' + m + ' left' : ''; }
    paintPc(h, n);
    var token = (h.__paint = (h.__paint || 0) + 1);
    livePrice(h, n, true).then(function (r) {
      if (token !== h.__paint) return;
      var s = q(h, '.nt-bia-each s'), b = q(h, '.nt-bia-each b');
      if (s) { s.textContent = money(r.unit); s.hidden = !r.off; }
      if (b) b.textContent = money(r.each);
      h.querySelectorAll('.nt-bia-off').forEach(function (el) { el.textContent = r.off ? r.off + '% off' : ''; el.hidden = !r.off; });
      var tot = q(h, '.nt-bia-tot b');
      if (tot) tot.textContent = money(r.each * n);
      var note = q(h, '.nt-bia-note');
      if (note && !h.__err) {
        var parts = [];
        if (r.kind === 'blank') {
          if (r.cartTotal) parts.push('the ' + money(r.cartTotal) + ' already in your cart');
          if (r.x.total) parts.push('your other lines here');
        } else {
          if (r.x.qty) parts.push(r.x.qty + ' from your other lines here');
          if (r.cartQty) parts.push(r.cartQty + ' already in your cart');
        }
        /* two+ lines open: the discount count moves to the order bar (syncBar), summed over every open line */
        note.hidden = !(r.off && parts.length) || openIn(scopeOf(h)).length > 1;
        note.classList.remove('is-err');
        note.textContent = parts.length ? (r.kind === 'blank' ? 'Tier price counts ' : 'Counts ') + parts.join(' and ') + (r.kind === 'blank' ? '' : ' toward this discount') : '';
      }
      h.__each = r.each; h.__n = n; h.__off = r.off; h.__kind = r.kind; h.__cartQty = r.cartQty || 0; h.__cartTotal = r.cartTotal || 0;
      syncBar(scopeOf(h));
    }, function () {});
    if (!quiet) paintAll(h);
  }
  /* the bar moves to a line when its quantity is clicked or focused (opening a line focuses it), never
     while typing (Owen 2026-10-22) */
  function focusLine(h) {
    var sc = scopeOf(h), was = (sc.__recent || []).slice(-1)[0];
    sc.__recent = (sc.__recent || []).filter(function (o) { return o !== h; }).concat(h);
    if (was !== h) syncBar(sc);
  }
  function setErr(h, msg) {
    var note = q(h, '.nt-bia-note');
    h.__err = !!msg;
    if (!note) return;
    note.classList.toggle('is-err', !!msg);
    if (msg) { note.textContent = msg; note.hidden = false; } else { paint(h, true); }
  }

  /* ---- several open lines: one bar per order, one add for all of them ---- */
  function syncBar(scope) {
    var open = openIn(scope), bar = scope.__bar && scope.__bar.isConnected ? scope.__bar : null;
    /* any line open: lines at rest drop their prices; two+ open = one add for all, so the open lines drop
       their own Add to Cart (the bar adds them). assets/nt-buy-again.css .nt-bia-any / .nt-bia-multi (Owen 2026-10-22) */
    scope.classList.toggle('nt-bia-any', open.length > 0);
    scope.classList.toggle('nt-bia-multi', open.length > 1);
    if (open.length < 2) { if (bar) bar.hidden = true; return; }
    if (!bar) {
      bar = document.createElement('div');
      bar.className = 'nt-bia-bar'; scope.__bar = bar;
      bar.innerHTML = '<span class="nt-bia-bar__sum"></span>' +
        '<span class="nt-bia-bar__acts"><button type="button" class="nt-bia-bar__close">Close all</button>' +
        '<button type="button" class="nt-bia-bar__add"></button></span><p class="nt-bia-bar__note" hidden></p>';
      var lists = scope.querySelectorAll('.nt-od-lines');
      var after = lists.length ? lists[lists.length - 1] : null;
      if (after) after.parentNode.insertBefore(bar, after.nextSibling); else scope.appendChild(bar);
    }
    /* the bar sits right under the line being edited (Owen 2026-10-22: at the bottom of a long list it was
       below the fold): after that line (and its Pre-cut sub-line), sharing its CSS order so it stays there */
    /* the line edited last that is still open, else the last open one on the page */
    var act = (scope.__recent || []).filter(function (o) { return open.indexOf(o) !== -1; }).pop() || open[open.length - 1];
    var arow = act && act.closest('.ao-line-item');
    if (arow && arow.parentNode) {
      var aid = arow.getAttribute('data-nt-line');
      var apc = aid ? arow.parentNode.querySelector('.ao-li-pc-sub[data-nt-pc-of="' + aid + '"]') : null;
      var anchor = apc || arow;
      if (anchor.nextSibling !== bar) anchor.parentNode.insertBefore(bar, anchor.nextSibling);
      bar.style.order = anchor.style.order || '';
    }
    var pieces = 0, total = 0;
    open.forEach(function (o) { pieces += o.__n || qtyOf(o); total += (o.__each || 0) * (o.__n || qtyOf(o)); });
    bar.querySelector('.nt-bia-bar__sum').innerHTML = '<b>' + open.length + ' lines</b> · ' + pieces + ' piece' + (pieces === 1 ? '' : 's') + ' · <b>' + money(total) + '</b>';
    /* what counts toward the discount: ALL the open lines above (per break group) + what is already in the cart */
    var groups = {}, gOrder = [], dollars = 0, blankOff = false, cartTotal = 0, msgs = [];
    open.forEach(function (o) {
      var n = o.__n || qtyOf(o);
      dollars += num(o.getAttribute('data-unit')) * n;
      if (o.__kind === 'blank') { if (o.__off) blankOff = true; cartTotal = o.__cartTotal || cartTotal; return; }
      var g = group(o);
      if (!g || o.__kind !== 'qty') return;
      if (!groups[g]) { groups[g] = { qty: 0, cart: 0, off: false }; gOrder.push(g); }
      groups[g].qty += n; groups[g].cart = o.__cartQty || groups[g].cart; if (o.__off) groups[g].off = true;
    });
    gOrder.forEach(function (g) {
      var x = groups[g];
      if (!x.off) return;
      msgs.push('Counts ' + x.qty + ' piece' + (x.qty === 1 ? '' : 's') + ' from your open lines' + (x.cart ? ' and ' + x.cart + ' already in your cart' : '') + ' toward this discount');
    });
    if (blankOff) msgs.push('Tier price counts the ' + money(dollars) + ' in your open lines' + (cartTotal ? ' and the ' + money(cartTotal) + ' already in your cart' : ''));
    var bnote = bar.querySelector('.nt-bia-bar__note');
    if (bnote) { bnote.textContent = msgs.join(' · '); bnote.hidden = !msgs.length; }
    var add = bar.querySelector('.nt-bia-bar__add');
    if (!add.hasAttribute('data-busy')) add.textContent = 'Add ' + open.length + ' lines to Cart';
    bar.hidden = false;
  }
  /* the line's cart properties, built exactly as the line's own Reorder handler builds them
     (my-orders-content / members-portal-layout / all-orders: decode urls, reorder note, print-ready file) */
  function propsFor(h) {
    var btn = realBtn(h), ta = q(h, '.ao-li-propdata'), props = {};
    var txt = ta ? String(ta.value || ta.textContent || '').trim() : '';
    if (txt) { try { props = JSON.parse(txt); } catch (e) { props = {}; } }
    /* NP: exactly as the line's own Reorder builds them (sections/my-orders-content.liquid): urls decoded, '+' back to a
       space, the pre-underscore property names renamed to their hidden form, and the _reorder note */
    Object.keys(props).forEach(function (k) {
      var v = props[k];
      if (typeof v !== 'string') return;
      props[k] = v.indexOf('https%3A%2F%2F') > -1 ? decodeURIComponent(v) : v.replace(/\+/g, ' ');
    });
    ['Upload', 'Original Image', 'cartImg', 'Remove Background', 'design re-used', 'Width (in)', 'Height (in)'].forEach(function (k) {
      if (Object.prototype.hasOwnProperty.call(props, k)) { props['_' + k] = props[k]; delete props[k]; }
    });
    props['_reorder'] = 'of order #' + btn.getAttribute('data-order-name') + ' / ' + btn.getAttribute('data-lineitem-id');
    return props;
  }
  function postItems(items) {
    return fetch('/cart/add.js', {
      method: 'POST', credentials: 'same-origin',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: items })
    }).then(function (r) { if (!r.ok) throw new Error('cart ' + r.status); return r.json(); });
  }
  function openCart() {
    if (typeof window.__aoOpenCartAfterReorder === 'function') { window.__aoOpenCartAfterReorder(); return; }
    try { if (typeof window.refreshCart === 'function') window.refreshCart(); } catch (e) {}
    setTimeout(function () {
      try { var sb = document.querySelector('[data-js-site-cart-sidebar]'); if (sb && typeof sb.show === 'function') { sb.show(); return; } } catch (e) {}
      try { var ic = document.querySelector('[data-js-toggle-cart-sidebar], [data-cart-drawer-toggle]'); if (ic) ic.click(); } catch (e) {}
    }, 300);
  }
  function addAll(scope, btn) {
    var open = openIn(scope).filter(function (o) { var b = realBtn(o); return b && !b.disabled; });
    if (!open.length || btn.hasAttribute('data-busy')) return;
    var items = open.map(function (o) {
      return { id: +realBtn(o).getAttribute('data-variant-id'), quantity: qtyOf(o), properties: propsFor(o) };
    });
    btn.setAttribute('data-busy', ''); btn.textContent = 'Adding…';
    if (window.NTReorderReview) window.NTReorderReview.loading();
    var addedLines = [];
    function finish(failed) {
      btn.removeAttribute('data-busy');
      var firstOk = null;
      open.forEach(function (o, i) {
        if (failed.indexOf(i) === -1) { if (!firstOk) firstOk = o; setOpen(o, false); flashAdded(o, items[i].quantity); }
        else setErr(o, 'Couldn’t add this line. Try again, or call us at 888-356-3665.');
      });
      syncBar(scope);
      var okN = open.length - failed.length;
      /* NP: no slide-out cart — the green "Added to cart" card (NTReorderReview.added, assets/nt-cart-actions.js) */
      if (okN > 0 && window.NTReorderReview && window.NTReorderReview.added) {
        var row = firstOk && firstOk.closest('.ao-line-item, .od-line-item'), img = row && row.querySelector('.ao-li-thumb img');
        window.NTReorderReview.added({ name: okN === 1 && row ? String((row.querySelector('.ao-li-name') || {}).textContent || '').trim() : okN + ' lines', thumb: img ? img.getAttribute('src') : '', lines: addedLines });
      } else {
        if (okN > 0) openCart();
        if (window.NTReorderReview && window.NTReorderReview.done) setTimeout(window.NTReorderReview.done, okN > 0 ? 1500 : 0);
      }
      if (window.NTQtyTiers) window.NTQtyTiers.reset();
      paintAllRest();
    }
    postItems(items).then(function (j) {
      (j && j.items || []).forEach(function (it, n) { if (it && it.key) addedLines.push({ key: it.key, qty: items[n] ? items[n].quantity : it.quantity }); });
      finish([]);
    }, function () {
      /* one line Shopify won't take refuses the whole batch: one at a time, keep the ones that fail open */
      var failed = [], i = 0;
      (function next() {
        if (i >= items.length) { finish(failed); return; }
        var k = i++;
        postItems([items[k]]).then(function (j) {
          var it = j && j.items && j.items[0];
          if (it && it.key) addedLines.push({ key: it.key, qty: items[k].quantity });
          next();
        }, function () { failed.push(k); next(); });
      })();
    });
  }
  function flashAdded(h, n) {
    if (h.__card) {   /* single-item card: the card's own Buy Again says it */
      var cb = h.__card.querySelector('[data-nt-single]'), ct = cb && cb.querySelector('.ao-btn-text, .ro-btn-text');
      if (!cb || !ct) return;
      cb.classList.add('nt-is-added'); ct.textContent = 'Added ' + n;
      setTimeout(function () { cb.classList.remove('nt-is-added'); ct.textContent = 'Buy Again'; }, 2000);
      return;
    }
    var o = q(h, '.nt-bia-open');
    if (!o) return;
    var t = o.querySelector('.nt-bia-open__t') || o;
    o.classList.add('is-added'); t.textContent = 'Added ' + n;
    setTimeout(function () { o.classList.remove('is-added'); t.textContent = 'Buy Again'; }, 2000);
  }

  /* ---- single-item cards (Owen 2026-10-22): the card's Buy Again opens the same quantity row inside
     the card. The row is a copy of the order's one line (its list line, or <template class="nt-od-src">),
     made on first click and only hidden on close, so assets/reorder-lp.js and the &item=N deep links
     (read at page load) see the order exactly as before. A line that can't use Buy Again (out of stock,
     variant gone) keeps the card's normal whole-order reorder. ---- */
  function singlePanel(btn) {
    var id = btn.getAttribute('data-nt-single');
    var card = btn.closest('.ao-order-row, .ao-order-row-mobile, .ro-order-row, .ro-order-row-mobile');
    if (!id || !card) return null;
    var panel = card.querySelector(':scope > .nt-single-lines');
    if (panel) return panel;
    var src = srcLine(id);
    if (!src || !src.querySelector(HOST)) return null;
    panel = document.createElement('div');
    panel.className = (card.className.indexOf('ro-') === 0 ? 'ro-line-items' : 'ao-line-items') + ' nt-single-lines';
    panel.hidden = true;
    var row = src.cloneNode(true), last = row;
    row.removeAttribute('hidden'); row.classList.remove('nt-bia-row--open', 'ao-li--vlast');
    panel.appendChild(row);
    var pc = pcOf(src, id);
    if (pc) { pc = pc.cloneNode(true); pc.classList.remove('ao-li--vlast'); panel.appendChild(pc); last = pc; }
    last.classList.add('ao-li--vlast');
    var h = row.querySelector(HOST);
    h.classList.remove('is-open'); h.__card = card;
    card.insertBefore(panel, card.querySelector(':scope > template.nt-od-src, :scope > .ao-line-items, :scope > .ro-line-items'));
    return panel;
  }
  document.addEventListener('click', function (e) {
    var btn = e.target.closest && e.target.closest('[data-nt-single]');
    if (!btn || btn.classList.contains('loading')) return;
    var panel = singlePanel(btn);
    if (!panel) return;
    e.preventDefault(); e.stopPropagation(); e.stopImmediatePropagation();
    setOpen(panel.querySelector(HOST), true);
  }, true);

  function setOpen(h, open) {
    if (h.__card) {
      var sp = h.closest('.nt-single-lines');
      if (sp) sp.hidden = !open;
      h.__card.classList.toggle('nt-single-open', open);
    }
    var openBtn = q(h, '.nt-bia-open'), inp = q(h, '.nt-bia-qn');
    if (open) inp.value = String(ordered(h));   /* several lines can be open at once (Owen 2026-10-21) */
    h.__err = false;
    h.classList.toggle('is-open', open);
    var row = h.closest('.nt-bia-row, .od-line-item');
    if (row) row.classList.toggle('nt-bia-row--open', open);
    if (openBtn) openBtn.setAttribute('aria-expanded', open ? 'true' : 'false');
    if (open) {
      if (window.NTQtyTiers) window.NTQtyTiers.reset();   /* the cart may have changed since the page loaded */
      paint(h);
      focusLine(h);
      try { inp.focus({ preventScroll: true }); inp.select(); } catch (e) {}
    } else {
      inp.value = String(ordered(h));
      var btn = realBtn(h);
      if (btn) btn.setAttribute('data-quantity', h.getAttribute('data-ordered') || '1');
      paintAll(h);
      paintRest(h);
    }
  }

  document.addEventListener('click', function (e) {
    var bar = e.target.closest && e.target.closest('.nt-bia-bar');
    if (bar) {
      var scope = scopeOf(bar);
      e.preventDefault(); e.stopPropagation();
      if (e.target.closest('.nt-bia-bar__add')) addAll(scope, e.target.closest('.nt-bia-bar__add'));
      else if (e.target.closest('.nt-bia-bar__close')) openIn(scope).forEach(function (o) { setOpen(o, false); });
      return;
    }
    var h = e.target.closest && e.target.closest(HOST);
    if (!h) return;
    if (e.target.closest('.nt-bia-open')) { e.preventDefault(); e.stopPropagation(); setOpen(h, true); return; }
    if (e.target.closest('.nt-bia-x')) { e.preventDefault(); e.stopPropagation(); setOpen(h, false); var o = q(h, '.nt-bia-open'); if (o) o.focus(); return; }
    var sp = e.target.closest('[data-nt-step]');
    if (sp) {
      e.preventDefault(); e.stopPropagation();
      focusLine(h);
      var inp = q(h, '.nt-bia-qn');
      inp.value = String(clamp(h, num(inp.value) + (+sp.getAttribute('data-nt-step'))));
      paint(h);
      return;
    }
    if (e.target.classList.contains('nt-bia-qn') && e.target.selectionStart === e.target.selectionEnd && !e.target.__sel) { e.target.__sel = true; e.target.select(); }
    if (e.target.closest('.nt-bia-edit')) e.stopPropagation();   /* never toggles the row's expand */
  });
  /* greyed-out Buy Again: a tap/click shows the why (hover and focus show it from CSS) */
  document.addEventListener('click', function (e) {
    var na = e.target.closest && e.target.closest('.nt-bia-na, .nt-ord-na');
    document.querySelectorAll('.nt-bia-na.is-tip, .nt-ord-na.is-tip').forEach(function (o) { if (o !== na) o.classList.remove('is-tip'); });
    if (na) { e.preventDefault(); e.stopPropagation(); na.classList.toggle('is-tip'); }
  });
  /* Add to Cart = the existing handler; after it has read data-quantity, put the line back at rest.
     The handler opens the cart either way, so watch its request: a refused add re-opens the line
     with an error instead of failing silently. */
  var pending = null;
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('.ao-li-reorder-btn');
    var h = b && b.closest(HOST);
    if (h && h.classList.contains('is-open')) {
      var n = qtyOf(h);
      pending = { h: h, id: b.getAttribute('data-variant-id'), n: n };
      setTimeout(function () { setOpen(h, false); }, 0);
    }
  }, true);
  if (window.jQuery) window.jQuery(document).on('ajaxComplete', function (ev, xhr, opts) {
    if (!pending || !opts || String(opts.url || '').indexOf('/cart/add') === -1) return;
    var data = typeof opts.data === 'string' ? opts.data : '';
    if (data && data.indexOf(pending.id) === -1) return;
    var p = pending; pending = null;
    if (window.NTQtyTiers) window.NTQtyTiers.reset();
    if (xhr && xhr.status >= 200 && xhr.status < 300) { flashAdded(p.h, p.n); return; }
    setOpen(p.h, true);
    q(p.h, '.nt-bia-qn').value = String(p.n); paint(p.h);
    setErr(p.h, 'Couldn’t add this line. Try again, or call us at 888-356-3665.');
  });
  document.addEventListener('input', function (e) {
    if (!e.target.classList || !e.target.classList.contains('nt-bia-qn')) return;
    e.target.value = e.target.value.replace(/\D/g, '').slice(0, 4);
    if (e.target.value) paint(e.target.closest(HOST));
  });
  document.addEventListener('change', function (e) {
    if (!e.target.classList || !e.target.classList.contains('nt-bia-qn')) return;
    var h = e.target.closest(HOST);
    e.target.value = String(clamp(h, num(e.target.value)));
    paint(h);
  });
  /* clicking into the box selects the number, so typing replaces it */
  document.addEventListener('focusin', function (e) {
    if (e.target.classList && e.target.classList.contains('nt-bia-qn')) { var fh = e.target.closest(HOST); if (fh && fh.classList.contains('is-open')) focusLine(fh); e.target.__sel = false; setTimeout(function () { try { e.target.select(); } catch (x) {} }, 0); }
  });
  document.addEventListener('keydown', function (e) {
    var h = e.target.closest && e.target.closest(HOST + '.is-open');
    if (!h) return;
    if (e.key === 'Escape') { setOpen(h, false); var o = q(h, '.nt-bia-open'); if (o) o.focus(); return; }
    if (!e.target.classList.contains('nt-bia-qn')) return;
    if (e.key === 'Enter') {
      e.preventDefault();
      e.target.value = String(clamp(h, num(e.target.value)));
      paint(h);
      var btn = realBtn(h);
      if (btn && !btn.disabled) btn.click();
    } else if (e.key === 'ArrowUp' || e.key === 'ArrowDown') {
      e.preventDefault();
      var s = q(h, '[data-nt-step="' + (e.key === 'ArrowUp' ? 1 : -1) + '"]');
      if (s && !s.disabled) s.click();
    }
  });

  /* Order Details shows the SAME line items as the My Orders list (Owen 2026-10-21): each line the
     details renderer drew (renderOdLineItem, matched by line item id) is swapped for a copy of that
     order's list line from snippets/order-line-items.liquid, inside its package section. One-line
     orders carry their line in a <template class="nt-od-src"> (all-orders-row / Recent Orders).
     The line's properties + fulfilled date from the details view stay under its name. Any line
     not found (an order whose row is not on the page) leaves that section as the details view drew it. */
  function srcLine(id) {
    var sel = '.ao-line-item[data-nt-line="' + id + '"]';
    var el = document.querySelector(sel);
    if (el) return el;
    var ts = document.querySelectorAll('template.nt-od-src');
    for (var i = 0; i < ts.length; i++) { el = ts[i].content.querySelector(sel); if (el) return el; }
    return null;
  }
  function pcOf(src, id) {
    var root = src.parentNode || document;
    return root.querySelector('.ao-li-pc-sub[data-nt-pc-of="' + id + '"]');
  }
  function fillDetails() {
    document.querySelectorAll('.od-section').forEach(function (sec) {
      var items = [].slice.call(sec.children).filter(function (c) { return c.matches && c.matches('.od-line-item[data-line-id]'); });
      if (!items.length) return;
      var found = items.map(function (od) { return srcLine(od.getAttribute('data-line-id')); });
      if (found.some(function (f) { return !f; })) return;
      var list = document.createElement('div');
      list.className = 'ao-line-items nt-od-lines';
      items.forEach(function (od, i) {
        var src = found[i], id = od.getAttribute('data-line-id');
        if (!src.hasAttribute('hidden')) {
          var row = src.cloneNode(true);
          row.classList.remove('ao-li--vlast', 'nt-bia-row--open');
          var h = row.querySelector('[data-nt-bia]');
          if (h) h.classList.remove('is-open');
          var info = row.querySelector('.ao-li-info');
          ['.od-line-item__props', '.od-line-item__fulfillment'].forEach(function (k) {
            var x = od.querySelector(k);
            if (x && info) info.appendChild(x);
          });
          list.appendChild(row);
          var pc = pcOf(src, id);
          if (pc) { pc = pc.cloneNode(true); pc.classList.remove('ao-li--vlast'); list.appendChild(pc); }
        }
        od.parentNode.removeChild(od);
      });
      /* the visually last line (CSS order: out of stock last) drops its bottom rule, as in the list */
      var last = null, max = -Infinity;
      [].slice.call(list.children).forEach(function (r) { var o = parseFloat(r.style.order) || 0; if (o >= max) { max = o; last = r; } });
      if (last) last.classList.add('ao-li--vlast');
      sec.appendChild(list);
      paintAllRest(list);
    });
  }
  document.addEventListener('click', function (e) {
    if (e.target.closest && e.target.closest('.ao-view-details-btn, .ro-view-details-btn')) setTimeout(fillDetails, 0);
  });

  /* ---- spaced-card layout (Owen 2026-10-22): which lines show before "See all", and the bottom /
     strip "See all" links, which work Justin's own .ao-see-items toggle so his expand logic stays the one
     source (snippets/all-orders-row.liquid) ---- */
  function markMore(root) {
    (root || document).querySelectorAll(':is(.ao-order-row, .ao-order-row-mobile).nt-inline > .ao-line-items').forEach(function (list) {
      if (list.__ntMarked) return;
      list.__ntMarked = true;
      var rows = [].slice.call(list.children).filter(function (r) {
        return r.classList.contains('ao-line-item') && !r.classList.contains('ao-li-pc-sub') && !r.hasAttribute('hidden');
      });
      rows.sort(function (a, b) { return (parseFloat(a.style.order) || 0) - (parseFloat(b.style.order) || 0); });
      rows.forEach(function (r, i) {
        var cls = i >= 3 ? 'nt-more' : i === 2 ? 'nt-more-ph' : '';
        if (!cls) return;
        r.classList.add(cls);
        var id = r.getAttribute('data-nt-line'), pc = id && list.querySelector('.ao-li-pc-sub[data-nt-pc-of="' + id + '"]');
        if (pc) pc.classList.add(cls);
      });
      var see = list.querySelector('.nt-see-row');
      if (see) {
        see.hidden = rows.length <= 2;
        see.classList.toggle('nt-see-ph-only', rows.length === 3);
      }
    });
  }
  function syncSee(row) {
    var open = row.classList.contains('expanded');
    row.querySelectorAll('[data-nt-see]').forEach(function (b) { b.textContent = open ? 'Hide items' : b.getAttribute('data-label'); });
  }
  document.addEventListener('click', function (e) {
    var b = e.target.closest && e.target.closest('[data-nt-see]');
    if (!b) return;
    e.preventDefault(); e.stopPropagation();
    var row = b.closest('.ao-order-row, .ao-order-row-mobile'), real = row && row.querySelector('.ao-see-items');
    if (real) real.click();
    if (row) setTimeout(function () { syncSee(row); }, 0);
  });

  /* live prices from the first paint, and again whenever the cart changes (its total moves the blanks
     tier; its DTF quantity moves the DTF break). Rows added later (My Orders loads more pages, search)
     are priced as they arrive. */
  function boot() { markMore(); paintAllRest(); }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot); else boot();
  document.addEventListener('cart-updated', function () {
    if (window.NTQtyTiers) window.NTQtyTiers.reset();
    paintAllRest();
    openIn(document.body).forEach(function (o) { paint(o, true); });
  });
  /* phones: an open card's Details / Invoice / button row sits UNDER its items (Owen 2026-10-22). The mobile
     card is its own element (.ao-order-row-mobile / .ro-order-row-mobile), so the row is moved after the last
     visible item list while the card is open (Justin's See all = .expanded, a single item = .nt-single-open)
     and put back when it closes. Handlers are delegated and find it by class, so moving it changes nothing else. */
  var MOB = '.ao-order-row-mobile, .ro-order-row-mobile';
  function placeActions(card) {
    var bottom = card.__ntBottom || (card.__ntBottom = card.querySelector('.all-orders__mobile-bottom, .recent-orders__mobile-bottom'));
    if (!bottom) return;
    var home = card.__ntHome || (card.__ntHome = bottom.parentNode);
    var last = null;
    if (card.classList.contains('expanded') || card.classList.contains('nt-single-open')) {
      [].slice.call(card.children).forEach(function (c) {
        if (c.matches('.ao-line-items, .ro-line-items') && !c.hidden && getComputedStyle(c).display !== 'none') last = c;
      });
    }
    /* touch the class only when it changes: the observer below watches card classes, and classList.add/remove
       re-writes the attribute even when nothing changes, which would re-trigger it forever */
    var below = card.classList.contains('nt-acts-below');
    if (last) { if (last.nextSibling !== bottom) last.parentNode.insertBefore(bottom, last.nextSibling); if (!below) card.classList.add('nt-acts-below'); }
    else { if (bottom.parentNode !== home) home.appendChild(bottom); if (below) card.classList.remove('nt-acts-below'); }
  }
  if (window.MutationObserver) {
    new MutationObserver(function (recs) {
      recs.forEach(function (r) {
        if (!r.target.matches || r.oldValue === r.target.className) return;
        if (r.target.matches(MOB)) placeActions(r.target);
        /* NP: a card just opened (See all): price the patch lines that were waiting to be seen */
        if (r.target.matches('.ao-order-row, .ao-order-row-mobile') && r.target.classList.contains('expanded')) {
          var card = r.target;
          setTimeout(function () { card.querySelectorAll('[data-nt-price]').forEach(function (h) { if (h.__restWait) paintRest(h); }); }, 30);
        }
      });
    }).observe(document.documentElement, { attributes: true, attributeFilter: ['class'], attributeOldValue: true, subtree: true });
  }
  if (window.MutationObserver) {
    var moT = null;
    new MutationObserver(function () {
      clearTimeout(moT);
      moT = setTimeout(function () {
        markMore();
        document.querySelectorAll(MOB).forEach(placeActions);   /* cards that load already open (pinned) */
        document.querySelectorAll('[data-nt-price]').forEach(function (h) { if (!h.__rest) paintRest(h); });
      }, 250);
    }).observe(document.documentElement, { childList: true, subtree: true });
  }
})();
